module.exports = __webpack_public_path__ + "img/cardio_sidebar.3a73b916.jpg";